module.exports = __webpack_public_path__ + "assets/img/PROCESS_PLUGIN.b112a08c.svg";